module.exports = __webpack_public_path__ + "img/brand-drachei-vert-white.af58ab5c.svg";